

import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import './OrganizationTreeSelect.css'

import { Box, Checkbox, Flex, Icon } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { lazy, useRef } from 'react'
import { flattenTree } from 'react-accessible-treeview'

const TreeView = lazy(() => import('react-accessible-treeview').then(module => ({ default: module.default })))

export interface OrganizationUnitTree {
    id: number
    name: string
    children: OrganizationUnitTree[]
}

export const OrganizationUnitTreeFlatten = (tree: OrganizationUnitTree): OrganizationUnitTree[] => {
    return [tree, ...tree.children.flatMap(OrganizationUnitTreeFlatten)]
}

export interface OrganizationTreeSelectProps<T extends OrganizationUnitTree> {
    data: T[]
    onSelectedIdsChanged?: (selectedIds: number[]) => void
    defaultSelectedIds: number[]
    detail?: (ou: T | undefined) => React.ReactNode
}

export function OrganizationTreeSelect<T extends OrganizationUnitTree>({
    data,
    onSelectedIdsChanged,
    defaultSelectedIds,
    detail
}: OrganizationTreeSelectProps<T>) {
    const treeViewRef = useRef(null)

    const treeData = data
        ? flattenTree({
            name: '',
            children: [
                {
                    name: 'Všechny organizace',
                    id: -1,
                    children: data,
                    metadata: {
                        id: null
                    }
                }
            ],
            metadata: {
                id: null
            },
        })
        : undefined

    const flattenData = data.flatMap(x => OrganizationUnitTreeFlatten(x))
console.log(flattenData);
    return (
        treeData && (
            <Box pl={4}>
                <TreeView
                    ref={treeViewRef}
                    className="tree-select"
                    data={treeData}
                    aria-label="Checkbox tree"
                    multiSelect
                    propagateSelect
                    propagateSelectUpwards
                    togglableSelect
                    defaultExpandedIds={[-1]}
                    defaultSelectedIds={defaultSelectedIds}
                    onSelect={(props) =>
                        onSelectedIdsChanged &&
                        onSelectedIdsChanged(
                            Array.from(props.treeState.selectedIds as Set<number>),
                        )
                    }
                    nodeRenderer={({
                        element,
                        isBranch,
                        isExpanded,
                        isSelected,
                        isHalfSelected,
                        getNodeProps,
                        level,
                        handleSelect,
                        handleExpand,
                    }) => {
                        return (<Flex
                            style={{ marginLeft: 24 * (level - 1) }}
                            {...getNodeProps({ onClick: handleExpand })}
                            alignItems='center'
                        >
                            {isBranch && <ArrowIcon isOpen={isExpanded} />}
                            <Checkbox
                                pl={1}
                                my={1}
                                ml={2}
                                isChecked={isSelected}
                                isIndeterminate={isHalfSelected}
                                onChange={(e) => {
                                    handleSelect(
                                        e as unknown as React.MouseEvent<unknown, unknown>,
                                    )
                                    e.stopPropagation()
                                }}
                                
                            >
                                {element.name}
                                {detail && detail(flattenData.find(d => d.id === element.metadata?.id) as T | undefined)}
                            </Checkbox>
                        </Flex>
                        )
                    }}
                />
            </Box>
        )
    )
}

const ArrowIcon = ({ isOpen }: { isOpen: boolean }) => {
    return (
        <Icon
            as={FontAwesomeIcon}
            icon={faChevronRight}
            boxSize={4}
            className={'arrow'}
            style={{ rotate: isOpen ? '90deg' : 'none' }}
        />
    )
}
